import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface EmailIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const EmailIcon: React.FC<EmailIconProps> = ({
  size = 16,
  color = 'iconPrimary',
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <Path
        d="M14.4 2H1.6C0.716344 2 0 2.67157 0 3.5V12.5C0 13.3284 0.716344 14 1.6 14H14.4C15.2837 14 16 13.3284 16 12.5V3.5C16 2.67157 15.2837 2 14.4 2ZM14.4 7.25L9.32 10.5875C8.52724 11.107 7.47276 11.107 6.68 10.5875L1.6 7.25V5.675L7.48 9.5375C7.7927 9.74096 8.2073 9.74096 8.52 9.5375L14.4 5.675V7.25Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
